import React from "react";

function TrendPill({ delta = 0 }) {
  const isUp = delta > 0;
  const isDown = delta < 0;
  const bg = isUp ? "rgba(34,197,94,0.16)" : isDown ? "rgba(239,68,68,0.16)" : "rgba(148,163,184,0.14)";
  const color = isUp ? "#22c55e" : isDown ? "#f87171" : "#94a3b8";
  const text = isUp ? `+${delta}` : `${delta}`;

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 999,
        background: bg,
        color,
        fontSize: 11,
        fontWeight: 800,
      }}
    >
      <span>{text}</span>
      <span style={{ opacity: 0.75, fontWeight: 700 }}>vs yesterday</span>
    </div>
  );
}

function Sparkline({ values = [] }) {
  const pts = values.length ? values : [0, 0, 0, 0];
  const w = 90;
  const h = 28;
  const min = Math.min(...pts, 0);
  const max = Math.max(...pts, 1);
  const range = Math.max(max - min, 1);

  const poly = pts.map((v, i) => {
    const x = (i / Math.max(pts.length - 1, 1)) * w;
    const y = h - ((v - min) / range) * (h - 4) - 2;
    return `${x},${y}`;
  }).join(" ");

  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
      <polyline
        fill="none"
        stroke="#47d7f4"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        points={poly}
      />
    </svg>
  );
}

export default function KPIBar({ items = [] }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 12 }}>
      {items.map((item, idx) => {
        const clickable = typeof item.onClick === "function";

        return (
          <button
            type="button"
            key={idx}
            onClick={item.onClick}
            style={{
              background: "linear-gradient(180deg, rgba(10,24,54,0.96), rgba(5,14,33,0.96))",
              border: "1px solid rgba(255,255,255,0.06)",
              borderRadius: 18,
              padding: 16,
              boxShadow: "0 8px 26px rgba(0,0,0,0.18)",
              textAlign: "left",
              color: "#fff",
              cursor: clickable ? "pointer" : "default",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "flex-start" }}>
              <div>
                <div style={{ fontSize: 12, opacity: 0.72, marginBottom: 8 }}>{item.title}</div>
                <div style={{ fontSize: 30, fontWeight: 900, lineHeight: 1.05 }}>{item.value}</div>
              </div>
              <Sparkline values={item.sparkline} />
            </div>
            <div style={{ marginTop: 10, display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center" }}>
              <TrendPill delta={item.delta} />
              <div style={{ fontSize: 11, opacity: 0.64, textAlign: "right" }}>{item.caption || ""}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
